import React, { PureComponent } from 'react';

import OneVisualLayout from '../../layouts/one-visual';

import Image from '../../../../../containers/assets/instructor-why-targets-werent-hit.png'

class WhyTargetsWerentHit extends PureComponent {
  render() {
    return (
      <OneVisualLayout
        section="Why Targets Weren’t Hit"
        title="Understanding Your Class Performance"
        paragraph1={(
          <p>There were a variety of reasons some teams were unable to hit all of their targets.  Let’s walk through each metric to explain the reasons.</p>
        )}
        visual={(
          <img src={Image} alt='Class Performance Overview' />
        )}
        visualProps={{
          noBorder: true,
          noBackground: true,
        }}
      />
    );
  }
}

export default WhyTargetsWerentHit;



// WEBPACK FOOTER //
// ./src/instructor/components/performance-feedback/pages/why-targets-werent-hit/index.js